import PropTypes from "prop-types"
import { isFunction } from "lodash"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material"
import SharedDate from "./components/shared-date"
import CopyableTextField from "components/copyable-text-field"
import OPTooltip from "components/material/tooltip"
import { Close, InfoOutlined, Share } from "@mui/icons-material"
import { getQueryStringState } from "helpers/queryString"
import { ABSOLUTE_DATE_PROPTYPE } from "helpers/shareMyView"
import { useRouterPath } from "hooks/router"
import { addShareMyViewProps } from "hooks/share-my-view"
import "./style.scss"

export default function ShareMyView({ createSharedLink, dateReducer, sharedLink, closeDialog, relativeDate, absoluteDate, size = "large" }) {
  const { path, params } = useRouterPath()

  function handleCreateSharedLink(useAbsoluteDate) {
    let queryString = getQueryStringState()

    queryString = addShareMyViewProps(queryString)

    if (useAbsoluteDate && isFunction(dateReducer)) {
      queryString = dateReducer(queryString)
    }
    createSharedLink({ urlTemplate: path, urlParams: params, queryString })
  }

  return <div className="modules_share-my-view">
    <OPTooltip title="Share this page"><IconButton onClick={() => handleCreateSharedLink(false)} size={size}><Share /></IconButton></OPTooltip>
    <Dialog fullWidth open={!!sharedLink} onClose={closeDialog} className="share-my-view-dialog">
      <DialogTitle>
        <div>
          Share link
          <OPTooltip
            slotProps={{ popper: { disablePortal: true } }}
            title={<>
              This share link captures the current state of the page & can be shared with anyone within your account — dataset & resource permissions will be enforced.
              <br />
              <br />
              If any changes are made to the page, please generate a new share link.
            </>}
            placement="right"
          >
            <InfoOutlined className="info-icon" />
          </OPTooltip>
        </div>
        <IconButton aria-label="close" onClick={closeDialog} size="large">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {dateReducer && <SharedDate relativeDate={relativeDate} absoluteDate={absoluteDate} onToggle={handleCreateSharedLink} />}
        <h3>Link to share</h3>
        <CopyableTextField useValueChangeEffect value={sharedLink} />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} color="primary">Return to Screen</Button>
      </DialogActions>
    </Dialog>
  </div>
}

ShareMyView.propTypes = {
  createSharedLink: PropTypes.func.isRequired,
  dateReducer: PropTypes.func,
  closeDialog: PropTypes.func.isRequired,
  sharedLink: PropTypes.string,
  relativeDate: PropTypes.string,
  size: PropTypes.string,
  absoluteDate: ABSOLUTE_DATE_PROPTYPE,
}
